<template>
    <div class="mx-auto">
        <PreloadSpinner :show="!preloaderState.minTimePassed || !preloaderState.dashboardLoaded" @hidden="startHotjar"></PreloadSpinner>
        <DashboardLayout>
            <router-view></router-view>
        </DashboardLayout>
        <LoadingPageOverlay />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useKeyboardNavigationClass from '@makeabledk/vue-ui/composables/keyboard-navigation-class';
import DashboardLayout from '@/components/layouts/dashboardLayout/DashboardLayout.vue';
import PreloadSpinner from '@/components/common/PreloadSpinner.vue';
import ApiClient from '@/plugins/store/actions/api/ApiClient';
import { store } from '@/plugins/store';
import LoadingPageOverlay from '@/components/common/LoadingPageOverlay.vue';

export default defineComponent({
    components: { DashboardLayout, PreloadSpinner, LoadingPageOverlay },
    data() {
        return {
            preloaderState: {
                minTimePassed: Object.hasOwnProperty.call(window, 'webpackHotUpdate'),
                dashboardLoaded: Object.hasOwnProperty.call(window, 'webpackHotUpdate'),
            },
            hasCheckedRealtimeOnly: false,
        };
    },
    computed: {
        dashboardLoaded(): boolean {
            return store.state.dashboardLoaded;
        },
        hasRealtimeOnlyModule(): boolean {
            return store.getters.hasRealtimeOnlyModule;
        },
        userProfileLoaded(): boolean {
            return store.state.user !== null;
        },
    },
    watch: {
        dashboardLoaded() {
            this.preloaderState.dashboardLoaded = true;
        },
        userProfileLoaded(newVal) {
            if (newVal && !this.hasCheckedRealtimeOnly) {
                this.checkAndRedirectIfRealtimeOnly();
            }
        },
    },
    created() {
        useKeyboardNavigationClass();
        if (this.userProfileLoaded && !this.hasCheckedRealtimeOnly) {
            this.checkAndRedirectIfRealtimeOnly();
        }
    },
    mounted() {
        // With HMR the spinner never shows, so its `hidden` event never fires.
        if (this.preloaderState.minTimePassed && this.preloaderState.dashboardLoaded) this.startHotjar();
        setTimeout(() => {
            this.preloaderState.minTimePassed = true;
        }, 2000);
    },
    methods: {
        startHotjar() {
            window.loadHotjar?.();
        },
        async waitForApiClient() {
            while (!ApiClient.apiState.userProfileLanguage || !ApiClient.apiState.authToken) await new Promise((resolve) => setTimeout(resolve, 100));
        },
        checkAndRedirectIfRealtimeOnly() {
            this.hasCheckedRealtimeOnly = true;
            if (this.hasRealtimeOnlyModule && (this.$route.path === '/overview' || this.$route.path === '/')) {
                this.$router.replace('/monitoring');
            }
        },
    },
});
</script>

<style>
body button:focus {
    outline: none !important;
}

body.--keyboard-navigation button:focus {
    box-shadow: 0 0 0 3px rgb(66 153 225 / 50%);
    border-color: #63b3ed;
}
</style>
